export enum QuestionTypeFile {
  FreeText = 'FreeText',
  RadioButton = 'Radio',
  MultipleChoice = 'Multi-Choice',
  Scale = 'Scale',
  Description = 'DescriptionText',
  MatrixTable = 'Matrix',
  RoleProfile = 'RoleProfile'
}
